var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3DotsScale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "hsl(228, 97%, 42%)",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 12,
    r: 3
  }, /*#__PURE__*/React.createElement("animate", {
    id: "spinner_jObz",
    begin: "0;spinner_vwSQ.end-0.25s",
    attributeName: "r",
    dur: "0.75s",
    values: "3;.2;3"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "spinner_jObz.end-0.6s",
    attributeName: "r",
    dur: "0.75s",
    values: "3;.2;3"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 12,
    r: 3
  }, /*#__PURE__*/React.createElement("animate", {
    id: "spinner_vwSQ",
    begin: "spinner_jObz.end-0.45s",
    attributeName: "r",
    dur: "0.75s",
    values: "3;.2;3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3DotsScale);
export default __webpack_public_path__ + "static/media/3-dots-scale.2867857b3d2da0a10dda3f82f4246fab.svg";
export { ForwardRef as ReactComponent };